<div class="l-form">
  <label translate *ngIf="label">{{ label }}</label>
  <span translate *ngIf="require" class="c-require">必須</span>
  <div class="l-form__content">
    <textarea
      #textarea
      [value]="control.value"
      [placeholder]="placeholder"
      (input)="onChange(textarea.value)"
      (blur)="onTouched()"
      required
      [ngClass]="{
        'c-error': control?.invalid && (control?.dirty || control?.touched)
      }"
    ></textarea>
    <div class="l-error">
      <div *ngIf="control?.invalid && (control?.dirty || control?.touched)">
        <div
          translate
          class="error-messege"
          *ngIf="control?.errors?.required"
          style="display: flex"
        >
          <p translate>{{ label }}</p>
          <!-- <p>+ "を入力してください。"</p> -->
          <p translate>&nbsp;{{ "error.required" }}</p>
        </div>
        <div
          translate
          *ngIf="control?.errors?.maxlength"
          class="error-messege"
          style="display: flex"
        >
          <p translate>{{ label }}</p>
          <p translate>&nbsp;{{ "error.maxValue" }}</p>
        </div>
      </div>
    </div>
  </div>
</div>
